import { WsDisconnectCode } from '@gem/modules/wsClient/wsServices';

import {
  disposeUnauthorizedCallsApi,
  unauthorizedWsCallsApiController,
} from './unauthorizedWsCallsApi/UnauthorizedWsCallsApi';
import { wsCallsApiController } from './wsCallsApi/WsCallsApi';

let isCallsWsApiInitiated = false;
let isUnauthorizedCallsWsApiInitiated = false;

export function wsCallsApiConnect(params: {
  session: string;
  channelId: string;
  refreshToken: () => Promise<string | null>;
  wsCallsUrl: string;
}): void {
  if (!wsCallsApiController) {
    throw new Error('wsCallsApiController should be initialized');
  }
  if (!isCallsWsApiInitiated) {
    wsCallsApiController.connect(params.session, params.wsCallsUrl, params.channelId);
    wsCallsApiController.refreshToken = params.refreshToken;

    isCallsWsApiInitiated = true;
  }
}

export function wsCallsApiDisconnect(): void {
  if (!wsCallsApiController) {
    throw new Error('wsCallsApiController should be initialized');
  }

  if (isCallsWsApiInitiated) {
    wsCallsApiController.disconnect(WsDisconnectCode.ManualClose);
    isCallsWsApiInitiated = false;
  }
}

export function unauthorizedWsCallsApiConnect(params: {
  session: string;
  channelId: string;
  refreshToken: () => Promise<string | null>;
  unauthorizedWsCallsUrl: string;
}): void {
  if (!unauthorizedWsCallsApiController) {
    throw new Error('unauthorizedWsCallsApiController should be initialized');
  }

  if (!isUnauthorizedCallsWsApiInitiated) {
    unauthorizedWsCallsApiController.connect(
      params.session,
      params.unauthorizedWsCallsUrl,
      params.channelId
    );
    unauthorizedWsCallsApiController.refreshToken = params.refreshToken;

    isUnauthorizedCallsWsApiInitiated = true;
  }
}

export function unauthorizedWsCallsApiDisconnect(): void {
  if (isUnauthorizedCallsWsApiInitiated) {
    if (!unauthorizedWsCallsApiController) {
      throw new Error('wsCallsApiController should be initialized');
    }
    unauthorizedWsCallsApiController.disconnect(WsDisconnectCode.ManualClose);
    disposeUnauthorizedCallsApi();
    isUnauthorizedCallsWsApiInitiated = false;
  }
}
